/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { TimeseriesLateral } from "./TimeseriesLateral";
import {
  TimeseriesLateralFromJSON,
  TimeseriesLateralFromJSONTyped,
  TimeseriesLateralToJSON,
  TimeseriesLateralToJSONTyped,
} from "./TimeseriesLateral";

/**
 *
 * @export
 * @interface PaginatedTimeseriesLateralList
 */
export interface PaginatedTimeseriesLateralList {
  /**
   *
   */
  count: number;
  /**
   *
   */
  next?: string | null;
  /**
   *
   */
  previous?: string | null;
  /**
   *
   */
  results: Array<TimeseriesLateral>;
}

/**
 * Check if a given object implements the PaginatedTimeseriesLateralList interface.
 */
export function instanceOfPaginatedTimeseriesLateralList(
  value: object
): value is PaginatedTimeseriesLateralList {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function PaginatedTimeseriesLateralListFromJSON(json: any): PaginatedTimeseriesLateralList {
  return PaginatedTimeseriesLateralListFromJSONTyped(json, false);
}

export function PaginatedTimeseriesLateralListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PaginatedTimeseriesLateralList {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(TimeseriesLateralFromJSON),
  };
}

export function PaginatedTimeseriesLateralListToJSON(json: any): PaginatedTimeseriesLateralList {
  return PaginatedTimeseriesLateralListToJSONTyped(json, false);
}

export function PaginatedTimeseriesLateralListToJSONTyped(
  value?: PaginatedTimeseriesLateralList | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(TimeseriesLateralToJSON),
  };
}
